import React from 'react'
import styled from '@emotion/styled'

function Cover() {

  return (
    <CoverContainer>
      <Span>Hey, I'm Luis.</Span>
      <DescriptionContainer>
        <P>
          Fullstack developer with +5 years of experience developing digital products for startups,  and using Javascript, NodeJs, Reactjs, several UI frameworks
           to create robust and scalable applications.
        </P>
        <P>
       Passioned for IA and LLMs, I'm a strong believer in the potential of AI systems, 
        </P>
      </DescriptionContainer>
      <div style=
        {{
          display: "flex",
          flexDirection: "row",
          marginTop: "40px"
        }}
      >
        <PrimaryButton  href="mailto:luiscode92@gmail.com">Email me</PrimaryButton>
        <SecondaryButton href='https://github.com/luiscode92'> Github</SecondaryButton>
        <ThirdButton href='https://twitter.com/luiscode92'> Twitter</ThirdButton>
      </div>
      <div style={{
          fontFamily: "Inter, sans-serif",
          marginTop: "100px",
          position: "relative",
          borderRadius: "6px",
          backgroundColor: "#f8f9fc",
          border: "solid 1px white",
          width: "560px",
          height: "50px"
        }}>
          <div style={{
              margin: 0,
              position: "absolute",
              top: "50%",
              left:"50%",
              transform: "translate(-50%,-50%)",
              color: "#868686",
              fontSize:"12px",
              fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;",
          }}>Project's section + articles, coming soon...  </div>
        </div>
    </CoverContainer>
  )
}

export default Cover

const CoverContainer = styled.div`
  max-width: 560px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 60px;
`

const P = styled.p`
  margin-top: 12px;
  margin-bottom: 0px;
  font-family: Inter, sans-serif;
  font-size: 28px;
  line-height: 38px;
  font-weight: 400;
`;

const Span = styled.span`
  font-size: 28px;
  font-height: 38px;
  font-weight: 900;
`;

const DescriptionContainer = styled.div`
  margin-top: 12px
`; 

const PrimaryButton = styled.a`
  background-color: white;
  color: black;
  padding: 12px 16px;
  border: 1px solid white;
  font-size: 18px;
  border-radius: 6px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: #f8f9fc;
    border: 1px solid #f8f9fc;
  }
`;

const SecondaryButton = styled.a`

  background-color: black;
  margin-left: 16px;
  color: white;
  padding: 12px 16px;
  border: 1px solid black;
  font-size: 18px;
  border-radius: 6px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: #1d1e20;
    border: 1px solid #1d1e20;
  }
`;

const ThirdButton = styled.a`

  background-color: #003166;
  margin-left: 16px;
  color: white;
  padding: 12px 16px;
  border: 1px solid black;
  font-size: 18px;
  border-radius: 6px;
  box-shadow: 0 4px 4px 0 rgb(0 0 0 / 10%);
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: #1DA1F2;
    border: 1px solid #1DA1F2;
  }
`;